import { useField } from 'vee-validate'
import type { RuleExpression } from "vee-validate";
import type { MaybeRef } from '@vueuse/shared'
import type { PropType } from '@vue/runtime-core'

export class ValidationProvider {
  static get props() {
    return {
      rules: {
        type: [Object, String, Function] as PropType<any>,
        default: () => null
      },
      validationMode: {
        type: String as PropType<'eager' | 'lazy' | 'aggressive'>,
        default: 'eager'
      }
    }
  }

  static use(
    id: string,
    name: string,
    initialValue: any,
    rules: MaybeRef<RuleExpression<any>>,
    validationMode: 'eager' | 'lazy' | 'aggressive' = 'eager'
  ) {
    const {
      value,
      errors,
      meta: { touched, dirty, valid, pending },
      errorMessage,
      resetField,
      setErrors,
      validate,
      handleChange: handleChangeInternal,
      handleBlur: handleBlurInternal,
      checked
    } = useField(id, rules, {
      label: name,
      initialValue,
      validateOnValueUpdate: false
    })

    const handleBlur = async (ev: Event | undefined) => {
      if (validationMode !== 'lazy') {
        await validate()
      }
      handleBlurInternal(ev)
    }

    const handleChange = (ev: Event | undefined) => {
      const shouldValidate =
        validationMode === 'eager' ? !!errorMessage.value : validationMode === 'aggressive'

      handleChangeInternal(ev, shouldValidate)
    }

    return {
      value,
      errors,
      touched,
      dirty,
      valid,
      pending,
      errorMessage,
      resetField,
      setErrors,
      validate,
      handleChange,
      handleBlur,
      checked
    }
  }
}
